import { render, staticRenderFns } from "./ProjectGroupDrawer.vue?vue&type=template&id=558adb98&scoped=true&"
import script from "./ProjectGroupDrawer.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectGroupDrawer.vue?vue&type=style&index=0&id=558adb98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558adb98",
  null
  
)

export default component.exports